import { useDashboardOverviewQuery } from '@/hooks/queries/use-dashboard-overview-query';
import { DashboardTodoCardView } from './DashboardTodoCardView';

/**
 * The dashboard's « À traiter » card, self-contained: it reads what waits on
 * the current brand on its own (never the overview filters), loads and fails
 * apart from the stats, and refetches when the brand changes or when a gesture
 * elsewhere stales its query.
 */
export const DashboardTodoCard = () => {
  const { data, isLoading, isError, refetch } = useDashboardOverviewQuery();

  return (
    <DashboardTodoCardView
      todo={data?.todo}
      isLoading={isLoading}
      isError={isError && !data}
      onRetry={() => void refetch()}
    />
  );
};
